import React from "react";
import { ConfirmationModification } from "./ConfirmationModification";
import { AlertIsExistArchivedModal } from "./AlertIsExistArchivedModal";
import { ModalNoEditModification } from "./ModalNoEditModification";
import { ConfirmationAssociation } from "./ConfirmationAssociation";

export default function VatRateModalsGroup({
    confirmationModificationClick,
    confirmationArchivedExistMessageClick,
    confirmationEditMessageClick,
    confirmationAssociationClick,

    handleValidate,
    type,
    canReplace,
    setIsAddVatRateClicked,
    setIsEdited,
    setConfirmationArchivedExistMessageClick,
    setConfirmationEditMessageClick,
    setConfirmationAssociationClick,

    isAddVatRateClicked,
    objAssoc,
    franchiseData,
    setIsSendingTag,
    setCanValidate,

    // toutes les données nécessaires
    userID,
    operatorID,
    uuidUser,
    franchiseID,
    dataVatRate,
    codeVateRate,
    vateRate,
    tagVateRateItem,
    paysVateRateItem,
}: any) {
    const confirmationObj = {
        userId: userID,
        operatorId: operatorID,
        uuidUser: uuidUser,
        shopId: 0,
        franchiseId: franchiseID,
        canReplace: true,
        data: [
            {
                id: dataVatRate?.selectedRow ? dataVatRate?.selectedRow.Id : 0,
                code: codeVateRate.trim(),
                value: vateRate,
                tag: tagVateRateItem,
                status:
                    typeof dataVatRate?.selectedRow === "object"
                        ? dataVatRate?.selectedRow.status
                        : true,
                pays: paysVateRateItem[0]?.value
                    ? paysVateRateItem.map((a: any) => a.value)
                    : [],
                archived:
                    typeof dataVatRate?.selectedRow === "object"
                        ? dataVatRate?.selectedRow.archived
                        : false,
                isFavorite:
                    typeof dataVatRate?.selectedRow === "object"
                        ? dataVatRate?.selectedRow.isFavorite
                        : false,
            },
        ],
    };

    return (
        <>
            {confirmationModificationClick && (
                <ConfirmationModification
                    handleValidate={handleValidate}
                    obj={confirmationObj}
                    type={type}
                    canReplace={canReplace}
                    setIsAddVatRateClicked={setIsAddVatRateClicked}
                    setIsEdited={setIsEdited}
                />
            )}

            <AlertIsExistArchivedModal
                isModalOpened={confirmationArchivedExistMessageClick}
                setIsModalOpened={setConfirmationArchivedExistMessageClick}
            />

            <ModalNoEditModification
                isModalOpened={confirmationEditMessageClick}
                setIsModalOpened={setConfirmationEditMessageClick}
                isAddVatRateClicked={isAddVatRateClicked}
                setIsAddVatRateClicked={setIsAddVatRateClicked}
                setIsEdited={setIsEdited}
            />

            <ConfirmationAssociation
                isModalOpened={confirmationAssociationClick}
                setIsModalOpened={setConfirmationAssociationClick}
                obj={objAssoc}
                handleValidate={handleValidate}
                franchiseData={franchiseData}
                setIsSendingTag={setIsSendingTag}
                setCanValidate={setCanValidate}
            />
        </>
    );
}
